/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import { Button as AntButton } from 'antd';
import { ButtonProps } from 'antd/es/button';

interface IButtonProps extends ButtonProps {
  // add new props here
}

const Button: React.FC<IButtonProps> = ({ children, ...props }) => (
  <AntButton {...props}>{children}</AntButton>
);

export default Button;
